"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.EmailDisclaimer = exports.ErrorMessage = exports.RegisterFormWrapper = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(["\n  padding: 10px;\n  border-radius: 10px;\n  text-align: left;\n  margin-bottom: 20px;\n  input {\n    border: 1px solid #ccc;\n    padding: 4px;\n  }\n  label {\n    width: 110px;\n  }\n  button {\n    border: 1px solid #333;\n    margin-left: 7px;\n  }\n"], ["\n  padding: 10px;\n  border-radius: 10px;\n  text-align: left;\n  margin-bottom: 20px;\n  input {\n    border: 1px solid #ccc;\n    padding: 4px;\n  }\n  label {\n    width: 110px;\n  }\n  button {\n    border: 1px solid #333;\n    margin-left: 7px;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  color: #ed4337;\n"], ["\n  color: #ed4337;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  color: #adaaaa;\n  margin-top: -9px;\n  padding: 0;\n  width: 100%;\n  @media (min-width: 992px) {\n    text-align: left;\n    margin-left: 124px;\n    margin-bottom: 8px;\n  }\n"], ["\n  font-size: 11px;\n  color: #adaaaa;\n  margin-top: -9px;\n  padding: 0;\n  width: 100%;\n  @media (min-width: 992px) {\n    text-align: left;\n    margin-left: 124px;\n    margin-bottom: 8px;\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  .register-header {\n    font-weight: 800;\n    margin-bottom: 6px;\n    font-size: 18px;\n    margin-top: 0px;\n  }\n  label {\n    margin-right: 10px;\n    text-align: left;\n  }\n  input {\n    width: 100%;\n    max-width: 350px;\n    margin-bottom: 12px;\n  }\n"], ["\n  .register-header {\n    font-weight: 800;\n    margin-bottom: 6px;\n    font-size: 18px;\n    margin-top: 0px;\n  }\n  label {\n    margin-right: 10px;\n    text-align: left;\n  }\n  input {\n    width: 100%;\n    max-width: 350px;\n    margin-bottom: 12px;\n  }\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAxios = require("@dreamchimney/react-axios");

var _Form = require("react-bootstrap/Form");

var _Form2 = _interopRequireDefault(_Form);

var _Button = require("react-bootstrap/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Spinner = require("react-bootstrap/Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactGoogleRecaptcha = require("react-google-recaptcha");

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _getUser = require("./api/getUser");

var _main = require("./utils/main");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RegisterFormWrapper = exports.RegisterFormWrapper = _styledComponents2.default.section(_templateObject);
var ErrorMessage = exports.ErrorMessage = _styledComponents2.default.section(_templateObject2);
var useSignUpForm = function useSignUpForm(initialValues, callback) {
  var _useState = (0, _react.useState)(initialValues),
      _useState2 = _slicedToArray(_useState, 2),
      inputs = _useState2[0],
      setInputs = _useState2[1];

  var handleSubmit = function handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }
    callback();
  };
  var handleInputChange = function handleInputChange(event) {
    event.persist();
    setInputs(function (inputs) {
      return _extends({}, inputs, _defineProperty({}, event.target.name, event.target.value));
    });
  };
  return {
    handleSubmit: handleSubmit,
    handleInputChange: handleInputChange,
    inputs: inputs
  };
};

var EmailDisclaimer = exports.EmailDisclaimer = _styledComponents2.default.section(_templateObject3);
var Wrapper = exports.Wrapper = _styledComponents2.default.section(_templateObject4);

var Register = function Register(_ref) {
  var _ref$opened = _ref.opened,
      opened = _ref$opened === undefined ? false : _ref$opened,
      onSuccess = _ref.onSuccess;

  //   const { state: userState, dispatch } = useUser();
  var _useState3 = (0, _react.useState)(opened),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasError = _useState6[0],
      setHasError = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      errorMsg = _useState10[0],
      setErrorMsg = _useState10[1];

  var recaptchaRef = _react2.default.createRef();

  (0, _react.useEffect)(function () {
    setOpen(opened);
  }, [opened]);

  function onCaptchaChange(value) {
    inputs.recaptchaValue = value;
  }

  function onCaptchaError() {
    console.log("Captcha Error");
    inputs.recaptchaValue = null;
  }

  var registerCb = function registerCb() {
    setLoading(true);
    var payload = _extends({}, inputs, { g_recaptcha_response: recaptchaRef.current && recaptchaRef.current.getValue() || null });
    (0, _getUser.userRegister)(_reactAxios.axiosAuth, _getUser.urlRegister, payload).then(function (_ref2) {
      var _ref2$data = _ref2.data,
          success = _ref2$data.success,
          user = _ref2$data.user,
          jwt = _ref2$data.jwt;

      console.log("*** Register success:", success);
      console.log("*** Register user:", user);
      if (success) {
        setHasError(false);
        setLoading(false);
        setErrorMsg("");
        inputs.loginemail = "";
        localStorage.setItem(_main.LOCAL_STORE_JWT, jwt);

        // any post login action - context
        //   dispatch({ type: "user_login", payload: { user } });
        if (onSuccess) {
          var successPayload = { dispatch: { type: "user_login", payload: { user: user } } };
          onSuccess(successPayload);
        }

        // @TODO any post login action - saving favorite. etc
        //   const loginSetTrackFav = localStorage.getItem("login_track_fav") || false;
        //   if (loginSetTrackFav) {
        //     setTrackFavorite(axios, loginSetTrackFav, { chim: user && user.dir }).then((data) =>
        //       localStorage.removeItem("login_track_fav")
        //     );
        //   }

        window.scrollTo(0, 0);
      } else {
        setHasError(true);
        setLoading(false);
      }
    }).catch(function (e) {
      console.log("register error", e);
      if (e.response && e.response.data && e.response.data.message) {
        setErrorMsg(e.response.data.message);
      } else {
        setErrorMsg("There was an error with login, please try again.");
      }
      setHasError(true);
      setLoading(false);
      window.grecaptcha.reset();
    });
  };

  var _useSignUpForm = useSignUpForm({ emailAddress: "", userName: "", password: "" }, registerCb),
      inputs = _useSignUpForm.inputs,
      handleInputChange = _useSignUpForm.handleInputChange,
      handleSubmit = _useSignUpForm.handleSubmit;
  //   if (!open || userState.loggedin) {


  if (!open) {
    return null;
  }

  return _react2.default.createElement(
    RegisterFormWrapper,
    null,
    _react2.default.createElement(
      _Form2.default,
      { className: "login-form", noValidate: true, onSubmit: handleSubmit },
      _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          "div",
          { className: "register-header" },
          "Create a Dream Chimney account below."
        ),
        _react2.default.createElement(
          "div",
          { style: { fontSize: "13px" } },
          "Save your favorite tracks, create your own profile page and more."
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement("hr", null)
        ),
        _react2.default.createElement(
          "div",
          null,
          loading && _react2.default.createElement(_Spinner2.default, { animation: "border", variant: "secondary" }),
          hasError && _react2.default.createElement(
            ErrorMessage,
            null,
            errorMsg
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "label",
            null,
            "Username"
          ),
          _react2.default.createElement("input", { type: "text", name: "userName", maxLength: "20", onChange: handleInputChange, value: inputs.userName, required: true })
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "label",
            null,
            "Email Address"
          ),
          _react2.default.createElement("input", { type: "email", name: "emailAddress", onChange: handleInputChange, value: inputs.emailAddress, required: true }),
          _react2.default.createElement(
            EmailDisclaimer,
            null,
            "* Email used for validation and password recovery only"
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "label",
            null,
            "Password"
          ),
          _react2.default.createElement("input", { type: "password", name: "password", onChange: handleInputChange, value: inputs.password, required: true, maxLength: "30" }),
          _react2.default.createElement(
            EmailDisclaimer,
            null,
            "* Password must be at least 6 chars using letters and numbers"
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "label",
            { style: { width: "100%" } },
            "Confirm you are human:"
          ),
          _react2.default.createElement(_reactGoogleRecaptcha2.default, {
            ref: recaptchaRef,
            sitekey: "6Lc8ZQwTAAAAAHTW5ccZa_qklcVAXncCSw-mxB-8",
            onExpired: onCaptchaError,
            onErrored: onCaptchaError,
            onChange: onCaptchaChange
          })
        ),
        _react2.default.createElement(
          _Button2.default,
          { style: { padding: "5px 20px", margin: "16px 0 0 0" }, variant: "secondary", size: "sm", type: "submit" },
          "Create Account"
        )
      )
    )
  );
};

Register.propTypes = {
  onSuccess: _propTypes2.default.func,
  opened: _propTypes2.default.bool
};

exports.default = Register;